<script setup>
import HeaderView from "./HeaderView.vue";
import CardContent from "@/components/ui/card/CardContent.vue";
import Card from "@/components/ui/card/Card.vue";
import Button from "@/components/ui/button/Button.vue";
import CardHeader from "@/components/ui/card/CardHeader.vue";
import Navigation from "@/components/Navigation.vue";

function login() {
  const loginUrl =
    `https://iprog.koda.re/auth/steam?redirect=` +
    encodeURIComponent(window.location.origin + "#/profile?from_auth=true");
  window.location.replace(loginUrl);
}

function loginTestUser() {
  const testUserUrl =
    `https://iprog.koda.re/auth/debug?redirect=` +
    encodeURIComponent(window.location.origin + "#/profile?from_auth=true");
  window.location.replace(testUserUrl);
}

// Attempt to go back repeatedly until we're not on /profile anymore.
// We impose a maxAttempts limit to avoid infinite loops in odd environments.
</script>

<template>
  <div
    class="w-fit h-fit flex flex-col items-center justify-center p-5 border-2 rounded-xl bg-card"
  >
    <div class="mb-4 text-center text-muted-foreground">
      To unlock the full potential of our application, you need to log in
    </div>
    <div class="flex flex-col w-full gap-5 max-w-xs align-item-center">
      <Button class="w-full" @click="login()"> Login with Steam</Button>
      <Button class="w-full" variant="outline" @click="loginTestUser()">
        Login as Test User</Button
      >
    </div>
  </div>
</template>
